export default {
  "SPD": "Sozialdemokratische Partei Deutschlands",
  "CDU / CSU": "Christlich Demokratische Union Deutschlands / Christlich-Soziale Union in Bayern e.V.",
  "GRÜNE": "BÜNDNIS 90/DIE GRÜNEN",
  "FDP": "Freie Demokratische Partei",
  "AfD": "Alternative für Deutschland",
  "Die Linke": "Die Linke",
  "SSW": "Südschleswigscher Wählerverband",
  "FREIE WÄHLER": "FREIE WÄHLER",
  "Tierschutzpartei": "PARTEI MENSCH UMWELT TIERSCHUTZ",
  "dieBasis": "Basisdemokratische Partei Deutschland",
  "Die PARTEI": "Partei für Arbeit, Rechtsstaat, Tierschutz, Elitenförderung und basisdemokratische Initiative",
  "Die Gerechtigkeitspartei - Team Todenhöfer": "Die Gerechtigkeitspartei - Team Todenhöfer",
  "PIRATEN": "Piratenpartei Deutschland",
  "Volt": "Volt Deutschland",
  "ÖDP": "Ökologisch-Demokratische Partei - Die Naturschutzpartei",
  "Verjüngungsforschung": "Partei für Verjüngungsforschung",
  "PdH": "Partei der Humanisten - Fakten, Freiheit, Fortschritt",
  "Bündnis C": "Bündnis C - Christen für Deutschland",
  "BP": "Bayernpartei",
  "MLPD": "Marxistisch-Leninistische Partei Deutschlands",
  "MENSCHLICHE WELT": "Menschliche Welt - für das Wohl und Glücklichsein aller",
  "PdF": "Partei des Fortschritts",
  "SGP": "Sozialistische Gleichheitspartei, Vierte Internationale",
  "BüSo": "Bürgerrechtsbewegung Solidarität",
  "BÜNDNIS DEUTSCHLAND": "BÜNDNIS DEUTSCHLAND",
  "BSW": "Bündnis Sahra Wagenknecht – Vernunft und Gerechtigkeit",
  "MERA25": "MERA25 - Gemeinsam für Europäische Unabhängigkeit",
  "WerteUnion": "WerteUnion"
};